<div class="table-column-count__container">
    <span [ngClass]="hasValue() ? '' : 'count-text--no-value'">{{getText()}}</span>
</div>